// import images from all-images/blog-img directory
import img01 from "../all-images/blog-img/blog1.jpg";
import img02 from "../all-images/blog-img/blog2.jpg";
import img03 from "../all-images/blog-img/blog3.jpg";

const blogData = [
  {
    id: 1,
    title: "Why regular car cleaning are worth it",
    author: "Dabrdige Company",
    date: "2026",
    time: "9pm",
    imgUrl: img01,
    description:
      " A proper car wash does 3 things: it protects, it saves you money and it makes driving feel good again. Wwashing the exterior removes mud, bird droppings and road salt that eats away at paint and cause rust.",
    quote:
      "Ready for that fresh-car feeling again?.",
  },

  {
    id: 2,
    title: "Why car rental is the smart way to travel",
    author: "Dabrdige Company",
    date: "2026",
    time: "9pm",
    imgUrl: img02,
    description:
      "Most rental companies now make it easy with online booking, flexible daily/weekly/monthly rates and extras like GPS, child seats and 24/7 roadside assistance. You get to choose self-drive or a chauffeur and you only pay for what you see.",
    quote:
      "Need wheels but don't want the stress of owning a car?.",
  },

  {
    id: 3,
    title: "More than just a Haircut",
    author: "Dabrdige Company",
    date: "2026",
    time: "9pm",
    imgUrl: img03,
    description:
      " Regular grooming matters too. Keeping your hair and beard neat protects your skin, prevents ingrowns and helps you look professional for work or events. Plus there's nothing like that fresh-cut feeling.",
    quote:
      "Walk in looking good. Walk out feeling even better",
  },
];

export default blogData;
